import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import moment from 'moment';

/**
 * Get statistics users
 * */
export function* getStatisticsUsers(from, until) {
    const response = yield call(api.getStatisticsUsers, from, until);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_STATISTICS_USERS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_STATISTICS_USERS.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetStatisticsUsers() {
    while (true) {
        const { from, until } = yield take(actionTypes.GET_STATISTICS_USERS.REQUEST);
        yield call(getStatisticsUsers, from, until);
    }
}

export default [
    watchGetStatisticsUsers,
]


// WEBPACK FOOTER //
// ./app/sagas/statistics/users.js